module.exports = __webpack_public_path__ + "img/code_bg.4d2aedbe.png";